module.exports = __webpack_public_path__ + "img/Noctiluca-Process-6.c5aad4d3.png";